import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostBinding,
  Input,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Table } from 'primeng/table';

import { Memoize } from '@core/decorators';

@Component({
  selector: 'z-sort-icon',
  templateUrl: './sort-icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class SortIconComponent implements OnInit, OnDestroy {
  destroy$ = new Subject<void>();

  @Input() field: string;

  sortOrder: number;

  @HostBinding('class') styleClass = 'p-element';

  constructor(public dataTable: Table, public cd: ChangeDetectorRef) {
    this.dataTable.tableService.sortSource$.pipe(takeUntil(this.destroy$)).subscribe((_sortMeta) => {
      this.updateSortState();
    });
  }

  ngOnInit() {
    this.updateSortState();
  }

  onClick(event: any) {
    event.preventDefault();
  }

  updateSortState() {
    if (this.dataTable.sortMode === 'single') {
      this.sortOrder = this.dataTable.isSorted(this.field) ? this.dataTable.sortOrder : 0;
    } else if (this.dataTable.sortMode === 'multiple') {
      const sortMeta = this.dataTable.getSortMeta(this.field);
      this.sortOrder = sortMeta ? sortMeta.order : 0;
    }

    this.cd.markForCheck();
  }

  @Memoize()
  getSortIcon(sortOrder: number) {
    if (sortOrder === 1) {
      return 'fa-sort-up';
    } else if (sortOrder === -1) {
      return 'fa-sort-down';
    } else {
      return 'fa-sort';
    }
  }

  getMultiSortMetaIndex() {
    const multiSortMeta = this.dataTable._multiSortMeta;
    let index = -1;

    if (multiSortMeta && this.dataTable.sortMode === 'multiple' && (this.dataTable.showInitialSortBadge || multiSortMeta.length > 1)) {
      for (let i = 0; i < multiSortMeta.length; i++) {
        const meta = multiSortMeta[i];
        if (meta.field === this.field || meta.field === this.field) {
          index = i;
          break;
        }
      }
    }

    return index;
  }

  getMultiSortNumber() {
    const index = this.getMultiSortMetaIndex();
    const value = this.dataTable.groupRowsBy && index > -1 ? index : index + 1;

    if (value > 9) {
      return `fa-square-plus`;
    } else {
      return `fa-square-${value}`;
    }
  }

  isMultiSorted() {
    return this.dataTable.sortMode === 'multiple' && this.getMultiSortMetaIndex() > -1;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
